const config = {};

config.staticUrl = process.env.NEXT_PUBLIC_STATIC_URL;
config.websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
config.webappUrl = process.env.NEXT_PUBLIC_WEBAPP_URL;
config.funnelUrl = process.env.NEXT_PUBLIC_FUNNEL_URL;

config.coral = {};
config.coral.url = process.env.NEXT_PUBLIC_CORAL_URL;

config.coral.campaignIds = {
  default: process.env.NEXT_PUBLIC_CORAL_CAMPAIGN_DEFAULT_ID,
  crm10euro: process.env.NEXT_PUBLIC_CORAL_CAMPAIGN_CRM10EURO_ID,
  crm20euro: process.env.NEXT_PUBLIC_CORAL_CAMPAIGN_CRM20EURO_ID,
  crm50euro: process.env.NEXT_PUBLIC_CORAL_CAMPAIGN_CRM50EURO_ID,
};

config.postAffiliateProUrl = process.env.NEXT_PUBLIC_POST_AFFILIATE_PRO_URL;

config.gtmCode = process.env.NEXT_PUBLIC_GTM_CODE;
config.mixpanelToken = process.env.NEXT_PUBLIC_MIXPANEL_API_KEY;
config.gaCode = process.env.NEXT_PUBLIC_GA_CODE;
config.rollbarAccessToken = process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN;
config.rollbarServerAccessToken = process.env.ROLLBAR_SERVER_ACCESS_TOKEN;
config.buildEnv = process.env.NEXT_PUBLIC_BUILD_ENV;
config.buildVersion = process.env.NEXT_PUBLIC_BUILD_VERSION;

config.trustpilotApiKey = process.env.TRUSTPILOT_API_KEY;

config.storyblok = {
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN,
  accountVersion: process.env.NEXT_PUBLIC_STORYBLOK_ACCOUNT_VERSION,
};

config.supWizChatWidgetUrl = process.env.NEXT_PUBLIC_SUPWIZ_URL;

config.googleSheetsApi = {
  email: process.env.GOOGLE_SHEETS_API_EMAIL,
  key: process.env.GOOGLE_SHEETS_API_KEY,
};

config.legalPartnersSheetId = process.env.LEGAL_PARTNERS_SHEET_ID;

config.magnitudeUrl = process.env.MAGNITUDE_URL;

config.scoresApiUrl = `${process.env.SCORES_API_URL}/scores`;

export default config;
